import { useCallback, useState } from 'react';
import { ListPaginationControlProps } from '../../ListPaginationControl';
import { usePageSizeState } from './usePageSizeState';

export interface UsePaginationStateParams {
  initialPageNumber?: number;
  initialPageSize?: number;
}

export interface UsePaginationStateReturn {
  pageSize: number;
  pageNumber: number;
  getListPaginationControlProps: () => Pick<ListPaginationControlProps, 'pageSize' | 'onPageSizeChange' | 'currentPage' | 'onPageChange'>;
}

export const usePaginationState = ({ initialPageNumber, initialPageSize }: UsePaginationStateParams = {}): UsePaginationStateReturn => {
  const { handlePageSizeChange, pageSize } = usePageSizeState({ initialPageSize });
  // TODO: implement pageNumber url param
  const [pageNumber, setPageNumber] = useState(initialPageNumber ?? 1);

  const handlePageChange = useCallback<(pageNumber: number) => void>(pageNumber => {
    setPageNumber(pageNumber);
  }, []);

  const getListPaginationControlProps = useCallback(() => {
    return {
      pageSize,
      onPageSizeChange: handlePageSizeChange,
      currentPage: pageNumber,
      onPageChange: handlePageChange,
    };
  }, [handlePageChange, handlePageSizeChange, pageNumber, pageSize]);

  return { pageNumber, pageSize, getListPaginationControlProps };
};
